module.exports = __webpack_public_path__ + "img/jing2.185d0178.jpg";